import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function scrollToHash(hash, attempt = 0) {
  const id = hash.slice(1);
  if (!id) return;

  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView();
    return;
  }

  if (attempt < 20) {
    requestAnimationFrame(() => scrollToHash(hash, attempt + 1));
  }
}

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    let frameId = 0;

    const runScroll = () => {
      if (hash) {
        scrollToHash(hash);
        return;
      }

      window.scrollTo(0, 0);
    };

    frameId = window.requestAnimationFrame(() => {
      frameId = window.requestAnimationFrame(runScroll);
    });

    return () => {
      window.cancelAnimationFrame(frameId);
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
